import React from 'react';

import ProductShowView from '@components/shared/products/ProductShowView';
import { useAdminNotification } from '@contexts/admin/AdminNotificationContext';
import { useMerchant } from '@contexts/admin/MerchantContext';
import { useLoaderData } from 'react-router-dom';

import { adminApiFetch } from '@services/admin/apiService';
import productService from '@services/admin/productService';
import productLabelTemplateService from '@services/admin/productLabelTemplateService';
import { thirdPartyApiLogService } from '@services/admin/thirdPartyApiLogService';
import { webhookDeliveryService } from '@services/admin/webhookDeliveryService';
import { partnerApiLogService } from '@services/admin/partnerApiLogService';

import adminCable from '@/lib/adminCable';

export default function ProductShow() {
  const product = useLoaderData();
  const { addJob } = useAdminNotification();
  const { currentMerchant } = useMerchant();

  return (
    <ProductShowView
      product={product}
      role="admin"
      productService={productService}
      labelTemplateService={productLabelTemplateService}
      thirdPartyApiLogService={thirdPartyApiLogService}
      webhookDeliveryService={webhookDeliveryService}
      partnerApiLogService={partnerApiLogService}
      addJob={addJob}
      cableManager={adminCable}
      merchantId={currentMerchant?.id}
    />
  );
}
